import { FC } from 'react';
import { Flex, Text } from '@chakra-ui/layout';
import { FaLock } from 'react-icons/fa';
import { convertChainIdToNetworkName } from 'utils/convertChainIdToNetworkName';

type Props = {
  chainId: number;
};

const ArtworkUnavailable: FC<Props> = ({ chainId }) => {
  return (
    <Flex flexDir='column' alignItems='center' py={6}>
      <FaLock fontSize='32px' />
      <Text mt={2}>
        Artwork currently unavailable on {convertChainIdToNetworkName(chainId)}
      </Text>
    </Flex>
  );
};

export default ArtworkUnavailable;
